import { SyntheticEvent } from 'react';

export const removeImageOnError = (event: SyntheticEvent<HTMLImageElement, Event>) => {
  event.currentTarget.src = '/images/generic/1x1-transparent.png';
  event.currentTarget.style.width = '1px';
  event.currentTarget.style.height = '1px';
};

export const validateImage = (src: string) => {
  return new Promise<boolean>((resolve) => {
    const image = new Image();

    image.onload = () => {
      resolve(true);
    };

    image.onerror = () => {
      resolve(false);
    };

    image.src = src;
  });
};

export default {
  removeImageOnError,
  validateImage,
};
